import { useEffect, useState } from "react";

export const FOCAL_OPTIONS = [
  { value: "center", label: "Centre" },
  { value: "top", label: "Top" },
  { value: "bottom", label: "Bottom" },
  { value: "left", label: "Left" },
  { value: "right", label: "Right" },
  { value: "top left", label: "Top left" },
  { value: "top right", label: "Top right" },
  { value: "bottom left", label: "Bottom left" },
  { value: "bottom right", label: "Bottom right" },
];

export const SCRIM_OPTIONS = [
  { value: "default", label: "Template default" },
  { value: "soft", label: "Soft" },
  { value: "medium", label: "Medium" },
  { value: "strong", label: "Strong" },
];

export const SCRIM_GRADIENT = {
  soft: "linear-gradient(to top, hsl(var(--background)/0.78), hsl(var(--background)/0.18) 55%, transparent)",
  medium: "linear-gradient(to top, hsl(var(--background)/0.92), hsl(var(--background)/0.45) 55%, hsl(var(--background)/0.12))",
  strong: "linear-gradient(to top, hsl(var(--background)/0.97), hsl(var(--background)/0.72) 55%, hsl(var(--background)/0.4))",
};

export function useIsMobile(query = "(max-width: 767px)") {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener("change", onChange);
    setIsMobile(mq.matches);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);

  return isMobile;
}
